import React from 'react';
import { Users } from '../../../utils/types';
import { CONFIG } from '../../../utils/config';
import { useNavigate } from 'react-router-dom';

interface UserListProps {
  data: Users[];
}

const UserList: React.FC<UserListProps> = ({ data }) => {
  const navigate = useNavigate();

  const handleEditClick = (ID: number) => {
    const url = CONFIG.urls.getUsersViewUrl_Admin(ID);
    navigate(url);
  };

  // Function to map roles to specific names
  const getRoleNames = (roles: any[]) => {
    if (roles.some(role => role.name.toLowerCase() === 'admin')) {
      return 'Admin';
    }
    if (roles.some(role => role.name.toLowerCase() === 'unitadmin')) {
      return 'Unit Admin';
    }

    return 'No roles assigned';
  };

  // Function to get the appropriate badge class based on the role
  const getBadgeClass = (roles: any[]) => {
    if (roles.some(role => role.name.toLowerCase() === 'admin')) {
      return 'text-bg-danger';  // Red badge for Admin
    }
    if (roles.some(role => role.name.toLowerCase() === 'unitadmin')) {
      return 'text-bg-success';  // Green badge for Unit Admin
    }

    return 'text-bg-secondary';  // Default badge color
  };

  return (
    <div id="usersList">
      <div className="row">
        {data.map((item) => (
          <div className="col-4 mb-4" key={item.id}>
            <div className="card h-100">
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <i className="bi bi-person-circle me-3 fs-1 user-icon"></i>
                  <div>
                    <h5 className="card-title text-primary mb-1">
                      <a className="text-decoration-none" href="#" onClick={() => handleEditClick(item.id)}>
                        {item.name}
                      </a>{/**.${getBadgeClass(item.roles)} */}
                    </h5>
                    <span className={`badge rounded-pill ${getBadgeClass(item.roles)} `}>
                      {getRoleNames(item.roles)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserList;
